import { AgrLoginTypes, IETFLocales, SignupSigninPolicy } from '@next/core-lib/environment';

import type { Environment } from './environment.model';

export const environment: Environment = {
  APPLICATION_NAME: 'PoultryNEXTRearing',
  API_BASE_URL: 'https://poultrynext-rearing.agrifirm.com',
  CLIENT_ID: '8c830f86-9b7a-4d6b-a6bb-140b5ffcbd9b',
  REDIRECT_URL: 'https://poultrynext-rearing.agrifirm.com',
  LOGIN_TYPE: AgrLoginTypes.redirect,
  SIGNUP_SIGNIN_POLICY: SignupSigninPolicy.All,
  PASSWORD_RESET_POLICY: 'B2C_1A_PasswordReset',
  AUTHORITY: 'https://agrifirmb2c.b2clogin.com/tfp/agrifirmb2c.onmicrosoft.com/',
  APPLICATION_KEY: 'PoultryNEXTRearing',
  AUTHORIZED_BY: {},
  APP_INSIGHTS_KEY: '85cd43e7-c453-4fae-af0f-f11c73380889',
  DEFAULT_LOCALE: IETFLocales.nl,
  LOCALES: [IETFLocales.nl],
  PRODUCTION: true,
  RELATIONSHIPS_ELASTIC_SEARCH: true,
  CUSTOMER_IN_LOCATION_SELECTOR: true,
  MSAL_LOGGING: false,
  NGRX_LOGGING: false,
  ERROR_PAGE_HOME_BUTTON: true,
  ERROR_PAGE_BACK_BUTTON: true,
  SHOW_DISABLED_LOCATION_BADGE: true,
  APIM_BASE_URL: 'https://gateway.api.agrifirm.com/external',
  KUBE_CONTAINER_NAME: '',
  KUBE_NODE_NAME: '',
  KUBE_POD_NAME: '',
  KUBE_TEAM: '',
  SHOP_URL: '',
  DELIVERY_TIME_WINDOW_DISABLED: false,
  SHOW_CART_ICON: false,
  SUBSCRIBE_TO_CART_EVENTS: false,
  IS_MY_PROSPECTS_HIDDEN: false,
  ARE_ORDER_BLOCKED_LOCATIONS_HIDDEN: false,
};
